import SiafLiteApiRepository from "../../external/siafLiteApi";

class DocumentoFreteService {
  constructor() {
    this.urlBase = "/estoque/documentos-frete";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default DocumentoFreteService;
